import { CookieHelper } from "../../core/helpers/CookieHelper";
import { SESSION_ENDED_REASON_COOKIE_KEY } from "../../core/constants/environment";

const LAST_ACTIVITY_COOKIE_KEY = "session_last_activity";

/**
 * One day. Deliberately far longer than any supported idle window (the
 * documented ceiling is 120 minutes) so the activity cookie can never expire
 * mid-session. SessionRepository reads a missing value as *fully idle* and
 * signs the member out, so a cookie that quietly lapsed would look identical
 * to someone who walked away.
 */
const SESSION_COOKIE_DAYS = 1;

/**
 * The two cookies backing the client-side session clock (PPI-1848).
 *
 * Separate from UserLocalDataSource on purpose: that one models the member's
 * credential, this one models how long this browser has been untouched. They
 * change for entirely different reasons, and the idle clock has no server
 * counterpart at all.
 */
export abstract class SessionLocalDataSource {
  abstract getLastActivity(): string;

  abstract setLastActivity(timestamp: number): void;

  abstract unsetLastActivity(): void;

  abstract getEndedReason(): string;

  abstract setEndedReason(reason: string): void;

  abstract unsetEndedReason(): void;
}

export class SessionLocalDataSourceImpl extends SessionLocalDataSource {
  cookieHelper: CookieHelper;

  constructor(cookieHelper: CookieHelper) {
    super();
    this.cookieHelper = cookieHelper;
  }

  getLastActivity = () => this.cookieHelper.getItem(LAST_ACTIVITY_COOKIE_KEY);

  setLastActivity = (timestamp: number) =>
    this.cookieHelper.setItem(
      LAST_ACTIVITY_COOKIE_KEY,
      String(timestamp),
      SESSION_COOKIE_DAYS
    );

  unsetLastActivity = () =>
    this.cookieHelper.setItem(LAST_ACTIVITY_COOKIE_KEY, null, -1);

  getEndedReason = () =>
    this.cookieHelper.getItem(SESSION_ENDED_REASON_COOKIE_KEY);

  setEndedReason = (reason: string) =>
    this.cookieHelper.setItem(
      SESSION_ENDED_REASON_COOKIE_KEY,
      reason,
      SESSION_COOKIE_DAYS
    );

  unsetEndedReason = () =>
    this.cookieHelper.setItem(SESSION_ENDED_REASON_COOKIE_KEY, null, -1);
}
